export default {"src":"/_next/static/media/fedex.3d8b3946.svg","height":512,"width":512};